import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {updateContactInfo,getContactInfo} from "../service/ContactInfo"
import { ContactInfoUpdate } from "../api/generated"

const CONTACTINFO = "CONTACTINFO"

export const useGetContactInfo = () => {
  return useQuery({
    queryKey: [CONTACTINFO],
    queryFn: () => getContactInfo()
  })
}

export const useUpdateContactInfo = ()=>{
      const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (contactInfoPayload:ContactInfoUpdate) => {
      return updateContactInfo(contactInfoPayload)
    },onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [CONTACTINFO],
      })
    }
  })

}

